<template>
  <el-tag type="danger" effect="dark" size="mini">
    <span>
      必須
    </span>
  </el-tag>
</template>
<script>
export default {
  name: 'RequiredTag'
}
</script>
